import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { recordNavigation } from "../utils/navigationHistory";
import { resolveCurrentContextLabel } from "./feedback/resolveCurrentContextLabel";

// Records every route change into the in-memory navigation trail (see
// utils/navigationHistory.ts) so feedback submissions can capture the page
// the user was on just before this one, not only a single current snapshot.
// Mounted once alongside PageTitleUpdater — same "no render output, just
// reacts to location changes" shape.
const NavigationHistoryTracker = () => {
  const location = useLocation();

  useEffect(() => {
    recordNavigation({
      route: `${location.pathname}${location.search}`,
      label: resolveCurrentContextLabel(location.pathname),
      visitedAt: Date.now(),
    });
  }, [location.pathname, location.search]);

  return null;
};

export default NavigationHistoryTracker;
